import { render, staticRenderFns } from "./UploadedFileTable.vue?vue&type=template&id=6f21965e&"
import script from "./UploadedFileTable.vue?vue&type=script&lang=js&"
export * from "./UploadedFileTable.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFileTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports